import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

type BillingSettingsTab = "settings" | "transactions";

interface BillingSettingsNavigationProps {
  activeTab: BillingSettingsTab;
}

export const BillingSettingsNavigation: React.FC<
  BillingSettingsNavigationProps
> = ({ activeTab }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const navigationItems: Array<{
    id: BillingSettingsTab;
    label: string;
    path: string;
  }> = [
    {
      id: "settings",
      label: t("billing.settingsTabs.settings"),
      path: "/billing-settings",
    },
    {
      id: "transactions",
      label: t("billing.settingsTabs.transactions"),
      path: "/billing-settings/transactions",
    },
  ];

  return (
    <nav
      aria-label={t("billing.settingsTabs.ariaLabel")}
      className="border-base-border flex w-fit items-center gap-1 rounded-lg border bg-white p-1"
    >
      {navigationItems.map((tab) => (
        <Button
          key={tab.id}
          type="button"
          variant={activeTab === tab.id ? "new_secondary" : "new_ghost"}
          className="min-w-[110px]"
          aria-current={activeTab === tab.id ? "page" : undefined}
          onClick={() => navigate(tab.path)}
        >
          {tab.label}
        </Button>
      ))}
    </nav>
  );
};
